import React from 'react';
import styled, { css } from 'styled-components';

import { basic } from '../../theme/colors';

interface StatusMessageProps {
  variant?: 'info' | 'success' | 'warning' | 'danger';
  children: React.ReactNode;
  icon?: React.ReactNode;
  compact?: boolean;
}

const StatusMessageWrapper = styled.div<{ variant: string; compact: boolean }>`
  display: flex;
  align-items: center;
  border-radius: 6px;
  padding: ${({ compact }) => (compact ? '6px 12px' : '10px 16px')};
  margin-bottom: 12px;
  font-size: 14px;
  line-height: 1.4;

  ${({ variant }) => {
    switch (variant) {
      case 'success':
        return css`
          background-color: ${basic.haydenGreenLight};
          color: ${basic.haydenGreen};
          border-left: 4px solid ${basic.haydenGreen};
        `;
      case 'warning':
        return css`
          background-color: ${basic.haydenOrangeLight};
          color: ${basic.haydenAnthracite};
          border-left: 4px solid ${basic.haydenOrange};
        `;
      case 'danger':
        return css`
          background-color: ${basic.haydenRedLight};
          color: ${basic.haydenAnthracite};
          border-left: 4px solid ${basic.haydenRed};
        `;
      case 'info':
      default:
        return css`
          background-color: ${basic.haydenAccentLight};
          color: ${basic.haydenAnthracite};
          border-left: 4px solid ${basic.haydenAccent};
        `;
    }
  }}
`;

const IconContainer = styled.div`
  margin-right: 10px;
  display: flex;
  align-items: center;
`;

const ContentContainer = styled.div`
  flex: 1;
`;

export const StatusMessage: React.FC<StatusMessageProps> = ({ variant = 'info', children, icon, compact = false }) => (
  <StatusMessageWrapper variant={variant} compact={compact}>
    {icon && <IconContainer>{icon}</IconContainer>}
    <ContentContainer>{children}</ContentContainer>
  </StatusMessageWrapper>
);
